import { useId, type InputHTMLAttributes, type ReactNode } from "react";
import { cn } from "./cn";

/**
 * ONAY KUTUSU
 *
 * ================================================================
 * NEDEN `Alan` BUNU KARSILAMIYOR
 * ================================================================
 * `Alan` etiketi kutunun USTUNE koyuyor ve 44px yukseklikte bir metin
 * kutusu ciziyor — onay kutusunda ikisi de yanlis: etiket YANDA
 * durur ve tiklama hedefi kutunun kendisi degil, kutu + etiketin
 * tamami olmalidir. `form-bileseni.test.ts` bekcisi de tam bu yuzden
 * `type="checkbox"`i kapsam disinda tutuyor.
 *
 * ================================================================
 * TIKLAMA HEDEFI ETIKETIN TAMAMI
 * ================================================================
 * Kutu 16px; tek basina birakilsaydi telefonda isabet ettirmesi zor
 * olurdu. `<label>` sarmalayici, metne dokunmayi da isaretleme
 * sayiyor ve satirin yuksekligi 44px'e tamamlaniyor.
 */
export interface OnayKutusuProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "id" | "type"
> {
  etiket: ReactNode;
  /** Etiketin altinda kucuk aciklama. */
  yardim?: ReactNode;
}

export function OnayKutusu({ etiket, yardim, className, ...rest }: OnayKutusuProps) {
  const id = useId();
  const yardimId = `${id}-yardim`;

  return (
    <div className="flex flex-col gap-1">
      <label
        htmlFor={id}
        className={cn("min-h-dokunma flex cursor-pointer items-center gap-2.5", className)}
      >
        <input
          {...rest}
          id={id}
          type="checkbox"
          aria-describedby={yardim ? yardimId : undefined}
          // `accent-color` tarayicinin kendi kutusunu markaya boyuyor:
          // kendi kutumuzu cizmek, isletim sisteminin erisilebilirlik
          // ayarlarini (yuksek kontrast, buyutme) kaybettirirdi.
          className="accent-marka-600 size-4 shrink-0 cursor-pointer disabled:cursor-not-allowed"
        />
        <span className="text-notr-700 text-[13.5px]">{etiket}</span>
      </label>
      {yardim && (
        <p id={yardimId} className="text-notr-600 pl-[26px] text-xs">
          {yardim}
        </p>
      )}
    </div>
  );
}
